import {
    NavbarLogoHomeButtonWrapper,
    NavbarLogoHomeButton,
    NavbarLogoImage,
    NavbarLogoImageTablet,
    ColumnNavbarLogoImage,
    ColumnNavbarLogoHomeButton,
    ColumnNavbarLogoHomeButtonWrapper,
} from "./navbarStyling";
import { guestModeSelector } from "../../../state/selectors/userModel";
import { useRecoilState } from "recoil";
import { useLocation, useNavigate } from "react-router-dom";
import { searchFiltersSelector } from "../../../state/selectors/searchQuery";
import { isUserChangePriceSelector } from "../../../state/selectors/isUserChangePrice";

function HomeButton({
    setNavbarMenu,
    setNavbarSearchMenuActivated,
    isHomeScrolled,
}: {
    setNavbarMenu: React.Dispatch<React.SetStateAction<boolean>>;
    setNavbarSearchMenuActivated: React.Dispatch<React.SetStateAction<boolean>>;
    isHomeScrolled: boolean;
}) {
    const [guestMode] = useRecoilState(guestModeSelector);
    const [searchFilters, setSearchFilters] = useRecoilState(searchFiltersSelector);
    const [, setIsUserChangePrice] = useRecoilState(isUserChangePriceSelector);
    const navigate = useNavigate();

    const location = useLocation();
    const isCollectionPage = location.pathname.includes("/collection");
    const isHomePage = location.pathname === "/";
    const useWhiteLogo = isCollectionPage || (isHomePage && !isHomeScrolled);

    const desktopLogoSrc = useWhiteLogo
        ? "https://d292awxalydr86.cloudfront.net/Branding/Anystay_white.svg"
        : "https://d292awxalydr86.cloudfront.net/Branding/Anystay.svg";
    const tabletLogoSrc = useWhiteLogo
        ? "https://d292awxalydr86.cloudfront.net/Branding/Anystay_logo_small_white.svg"
        : "https://d292awxalydr86.cloudfront.net/Branding/Anystay+logo+small.svg";

    if (!guestMode) {
        if (
            !location.pathname.includes("/profile") &&
            !location.pathname.includes("/edit-profile") &&
            !location.pathname.includes("/security-settings") &&
            !location.pathname.includes("/payment-settings") &&
            !location.pathname.includes("/payout-settings") &&
            !location.pathname.includes("/host/profile") &&
            !location.pathname.includes("/invite")
        ) {
            return (
                <ColumnNavbarLogoHomeButtonWrapper>
                    <ColumnNavbarLogoHomeButton
                        onClick={() => {
                            setNavbarMenu(false);
                            navigate("/dashboard");
                        }}
                    >
                        <ColumnNavbarLogoImage src={"https://d292awxalydr86.cloudfront.net/Branding/Anystay+logo+small.svg"} alt={"Anystay Logo"} />
                    </ColumnNavbarLogoHomeButton>
                </ColumnNavbarLogoHomeButtonWrapper>
            );
        } else {
            return (
                <NavbarLogoHomeButtonWrapper>
                    <NavbarLogoHomeButton
                        onClick={() => {
                            setNavbarMenu(false);
                            navigate("/dashboard");
                        }}
                    >
                        <NavbarLogoImage location={location.pathname} src={desktopLogoSrc} alt={"Anystay Logo"} />
                    </NavbarLogoHomeButton>
                </NavbarLogoHomeButtonWrapper>
            );
        }
    }
    return (
        <NavbarLogoHomeButtonWrapper location={location.pathname}>
            <NavbarLogoHomeButton
                onClick={() => {
                    setNavbarSearchMenuActivated(false);
                    setNavbarMenu(false);
                    const searchFiltersCopy = JSON.parse(JSON.stringify(searchFilters));
                    // category removed
                    setSearchFilters(searchFiltersCopy);
                    if (location.pathname !== "/") {
                        setIsUserChangePrice(false);
                    }
                    navigate("/");
                }}
            >
                <NavbarLogoImage location={location.pathname} src={desktopLogoSrc} alt={"Anystay Logo"} />
                <NavbarLogoImageTablet src={tabletLogoSrc} alt={"Anystay Logo"} />
            </NavbarLogoHomeButton>
        </NavbarLogoHomeButtonWrapper>
    );
}

export default HomeButton;
